import { IsEmail, IsEnum, IsNotEmpty, IsOptional, IsPhoneNumber, IsString, ValidateIf } from 'class-validator';
import i18n from '../i18n';

export enum ContactMethod {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  SMS = 'SMS',
}
export default class AgentContactForm {
  @IsString()
  @IsNotEmpty()
  public agentId: string;

  @IsString()
  @IsNotEmpty({
    message: i18n.t('FirstNameRequired'),
  })
  public firstName: string;

  @IsString()
  @IsNotEmpty({
    message: i18n.t('LastNameRequired'),
  })
  public lastName: string;

  @IsString()
  @IsOptional()
  @ValidateIf((o) => o.mobilePhone)
  @IsPhoneNumber('US', { message: i18n.t('PhoneNumberInvalid') })
  public mobilePhone?: string;

  @IsString()
  @IsOptional()
  @ValidateIf((o) => o.email)
  @IsEmail(undefined, { message: i18n.t('EmailInvalid') })
  public email?: string;

  @IsEnum(ContactMethod)
  @IsOptional()
  public preferredMethod: ContactMethod | null = null;

  @IsString()
  @IsNotEmpty({ message: i18n.t('MessageRequired') })
  public message: string;

  constructor(a: Partial<AgentContactForm> = {}) {
    this.agentId = a.agentId || '';
    this.firstName = a.firstName || '';
    this.lastName = a.lastName || '';
    this.mobilePhone = a.mobilePhone || '';
    this.email = a.email || '';
    this.preferredMethod = a.preferredMethod || null;
    this.message = a.message || '';
  }
}
